module.exports = __webpack_public_path__ + "img/1.ae17c11b.png";